<template>
  <div class="bb-main-page">
  </div>
</template>

<script>

export default {
  name: 'MainPage'
}
</script>

<style lang="scss" scoped>
  @import "../sass/_variables";

  .bb-main-page {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/containers/MainPage.vue